/*
    Configurazione dell'applicazione diversificata per ambiente:
    dev: ambiente di sviluppo
    staging: ambiente di staging
    production: ambiente di produzione
 */
import {get} from './Storage';
var AppSettings = get();
var localStorageName = "123ZsmDinVM4v_sWR8uH";
var cacheMinutes = parseInt(AppSettings.cacheduration);
if(cacheMinutes <= 0 || isNaN(cacheMinutes)){
    if (typeof(Storage) !== "undefined") {
        sessionStorage.removeItem(localStorageName);
    }
    cacheMinutes = 0;
}

export default {
    development: {
        name: "dev",
        urlUserBoxUser: "/json/user.json",
        urlUserBoxGetUserSettings: "/json/usersettings.json",
        urlUserBoxSetUserSettings: "/json/usersettings.json",
        urlUserBoxBaseInfo: "/json/userboxbaseinfo.json",
        urlUserBoxCountCoupons: "/json/userboxcountcoupons.json",
        urlUserBoxCountMissions:  "/json/userboxcountmissions.json",
        urlUserBoxCountNews: "/json/userboxcountnews.json",
        urlUserBoxTabProfile: "/json/userboxprofile.json",
        urlUserBoxGetNews : "/json/getnews.json" ,
        urlUserBoxTabNews : "/json/news.json",
        urlUserBoxTabControlPanel : "/json/userboxcontrolpanel.json",
        urlUserBoxLoyaltySystem: "/json/loyaltysystemuserbox.json",
        urlUserBoxNewsSetReadByuser: "/json/setreadbyuser.json",
        urlUserBoxTabCoupon : "/json/userboxcoupons.json",
        urlUserBoxTicketsList: "/json/ticketslist.json",
        urlUserBoxProactiveCashoutList: "/json/list.json",
        urlAssignedFreebet: "/json/assignedfreebet.json",
        urlUserBoxTerrestreTicketsList: "/json/ticketslistTerrestre.json",
        urlUserBoxGetBalance: "/json/balance.json",
        urlUserBoxGetTokenQrCode: "/json/encrypt.json",
        urlUserBoxLastLogin: "/json/lastlogin.json",
        urlUserBoxBalanceSubaccounts: "/json/userboxbalancesubaccounts.json",
        urlUserBoxGetSessionExpiration: "/json/sessionsxpiration.json",
        urlUserBoxGetCasinoGame: "/json/casinogetgame.json",
        // Ricarica/Prelievo
        urlUserBoxGetDepositTools: "/json/deposittool.json",
        urlUserBoxGetWithdrawalTools: "/json/withdrawal.json",
        //Memobet
        urlUserBoxGetListMemobet: "/json/memobetlist.json",
        urlUserBoxGetMemobet: "/json/memobet.json",

        urlCashOutDo: "/json/docashout.json",
        urlCashOutAsk: "/json/askcashout.json",

        // Deposit
        urlUserBoxDeposit:{
            "ecoupon" :"/json/depositWithdrawal/depositByEcoupon.json"
        },
        // Prelievo
        urlUserBoxWithdrawal:{},

        //localStorageName: {name: localStorageName, lifeTime: (cacheMinutes * 60 * 1000)},
        localStorageName: {name: localStorageName, lifeTime: (10 * 1000)},
        localStorageToggleBalance: "",
        localStorageKomodoTour: "ub_komodo_tour_v1",
        cookieNameToolbarMode: "",

        casinoDomain: "staging-casino.peoples.it",
        casinoImgDomain: "casino.peoples.it",
        //CRM
        urlUserBoxTabMissions : "/json/userboxmissions.json",
        urlUserCountMissions :"/json/userboxcountmissions.json",
        urlMasterAgentInfo: "/json/mandatoryinfo.json",
    },

    staging: {
        name: "staging",
        urlUserBoxUser: "/membership.svc/v1/user/",
        urlUserBoxGetUserSettings: "/membership.svc/v1/usersetting/UserBox/",
        urlUserBoxSetUserSettings: "/membership.svc/v1/usersetting",
        urlUserBoxBaseInfo: "/membership.svc/v1/userboxbaseinfo",
        urlUserBoxCountCoupons: "/membership.svc/v1/userboxcountcoupons/",
        urlUserBoxCountMissions: "/membership.svc/v1/userboxcountmissions/",
        urlUserBoxCountNews: "/membership.svc/v1/userboxcountnews/",
        urlUserBoxTabProfile: "/membership.svc/v1/userboxprofile/",
        urlUserBoxTabNews : "/CommunicationService.svc/v1/news/inbox/private/",
        urlUserBoxTabControlPanel : "/membership.svc/v1/userboxcontrolpanel/",
        urlUserBoxLoyaltySystem: "/membership.svc/v1/loyalty/system/userbox",
        urlUserBoxTabCoupon : "/membership.svc/v1/userboxcoupons/",
        urlUserBoxGetNews : "/CommunicationService.svc/v1/article/[NEWS_ID]/[READ]",
        urlUserBoxNewsSetReadByuser: "/CommunicationService.svc/v1/article/[NEWS_ID]",
        //urlUserBoxTicketsList: "/SportsBookAPI.svc/v1/TicketsList/0/[END_DATE]/[START_DATE]/20",
        urlUserBoxTicketsList: "/SportsBookAPI.svc/v4/TicketsList/userbox/0/[END_DATE]/[START_DATE]/20/",
        urlUserBoxProactiveCashoutList: "/SportsBookAPI.svc/v1/cashout/ask/list",
        urlAssignedFreebet: "/SportsBookAPI.svc/v1/freebets/assigned",
        urlUserBoxGetBalance: "/membership.svc/v1/balance/",
        urlUserBoxGetTokenQrCode: "/SecurityServiceAPI.svc/encrypt",
        urlUserBoxLastLogin: "/membership.svc/v1/lastlogins/",
        urlUserBoxBalanceSubaccounts: "/membership.svc/v1/balancesubaccounts/",
        urlUserBoxGetSessionExpiration:"/membership.svc/SessionExpiration",
        urlUserBoxGetCasinoGame: "/casino.svc/v1/getgame/[CODE]",
        // Ricarica/Prelievo
        urlUserBoxGetDepositTools:"/FinancialService.svc/v1/paymenttools/deposit/",
        urlUserBoxGetWithdrawalTools: "/FinancialService.svc/v1/paymenttools/withdrawal/",
        //Memobet
        urlUserBoxGetListMemobet: "/SportsBookAPI.svc/MyCarts/",
        urlUserBoxGetMemobet: "/SportsBookAPI.svc/Cart/[CODE]/",
        urlCashOutDo: "/SportsBookAPI.svc/v1/cashout/do",
        urlCashOutAsk: "/SportsBookAPI.svc/v1/cashout/ask/[TicketId]/",
        // Deposit
        urlUserBoxDeposit:{
            "ecoupon" :"/FinancialService.svc/v1/deposit/ecoupon"
        },
        urlUserBoxWithdrawal:{},

        //localStorageName: {name: localStorageName, lifeTime: (cacheMinutes * 60 * 1000)},
        localStorageName: {name: localStorageName, lifeTime: (10 * 1000)},
        localStorageToggleBalance: "",
        localStorageKomodoTour: "ub_komodo_tour_v1",
        cookieNameToolbarMode: "",

        casinoDomain: "staging-casino.peoples.it",
        casinoImgDomain: "casino.peoples.it",
        //CRM
        urlUserBoxTabMissions : "/membership.svc/v1/userboxmissions/",
        urlUserCountMissions :"/membership.svc/v1/userboxcountmissions/",
        urlMasterAgentInfo: "/membership.svc/v1/masteragent/info",
    },

    production: {
        name: "production",
        urlUserBoxUser: "/membership.svc/v1/user/",
        urlUserBoxGetUserSettings: "/membership.svc/v1/usersetting/UserBox/",
        urlUserBoxSetUserSettings: "/membership.svc/v1/usersetting",
        urlUserBoxBaseInfo: "/membership.svc/v1/userboxbaseinfo",
        urlUserBoxCountCoupons: "/membership.svc/v1/userboxcountcoupons/",
        urlUserBoxCountMissions: "/membership.svc/v1/userboxcountmissions/",
        urlUserBoxCountNews: "/membership.svc/v1/userboxcountnews/",
        urlUserBoxTabProfile: "/membership.svc/v1/userboxprofile/",
        urlUserBoxTabNews : "/CommunicationService.svc/v1/news/inbox/private/",
        urlUserBoxTabControlPanel : "/membership.svc/v1/userboxcontrolpanel/",
        urlUserBoxLoyaltySystem: "/membership.svc/v1/loyalty/system/userbox",
        urlUserBoxTabCoupon : "/membership.svc/v1/userboxcoupons/",
        urlUserBoxGetNews : "/CommunicationService.svc/v1/article/[NEWS_ID]/[READ]",
        urlUserBoxNewsSetReadByuser: "/CommunicationService.svc/v1/article/[NEWS_ID]",
        //urlUserBoxTicketsList: "/SportsBookAPI.svc/v1/TicketsList/0/[END_DATE]/[START_DATE]/20",
        urlUserBoxTicketsList: "/SportsBookAPI.svc/v4/TicketsList/userbox/0/[END_DATE]/[START_DATE]/20/",
        urlUserBoxProactiveCashoutList: "/SportsBookAPI.svc/v1/cashout/ask/list",
        urlAssignedFreebet: "/SportsBookAPI.svc/v1/freebets/assigned",
        urlUserBoxGetBalance: "/membership.svc/v1/balance/",
        urlUserBoxGetTokenQrCode: "/SecurityServiceAPI.svc/encrypt",
        urlUserBoxLastLogin: "/membership.svc/v1/lastlogins/",
        urlUserBoxBalanceSubaccounts: "/membership.svc/v1/balancesubaccounts/",
        urlUserBoxGetSessionExpiration:"/membership.svc/SessionExpiration",
        urlUserBoxGetCasinoGame: "/casino.svc/v1/getgame/[CODE]",
        // Ricarica/Prelievo
        urlUserBoxGetDepositTools:"/FinancialService.svc/v1/paymenttools/deposit/",
        urlUserBoxGetWithdrawalTools: "/FinancialService.svc/v1/paymenttools/withdrawal/",
        //Memobet
        urlUserBoxGetListMemobet: "/SportsBookAPI.svc/MyCarts/",
        urlUserBoxGetMemobet: "/SportsBookAPI.svc/Cart/[CODE]/",

        urlCashOutDo: "/SportsBookAPI.svc/v1/cashout/do",
        urlCashOutAsk: "/SportsBookAPI.svc/v1/cashout/ask/[TicketId]/",


        // Deposit
        urlUserBoxDeposit:{
            "ecoupon" :"/FinancialService.svc/v1/deposit/ecoupon"
        },
        urlUserBoxWithdrawal:{},

        //localStorageName: {name: localStorageName, lifeTime: (cacheMinutes * 60 * 1000)},
        localStorageName: {name: localStorageName, lifeTime: (60 * 1000)},
        localStorageToggleBalance: "",
        localStorageKomodoTour: "ub_komodo_tour_v1",
        cookieNameToolbarMode: "",

        casinoDomain: "casino.peoples.it",
        casinoImgDomain: "casino.peoples.it",
        //CRM
        urlUserBoxTabMissions : "/membership.svc/v1/userboxmissions/",
        urlUserCountMissions :"/membership.svc/v1/userboxcountmissions/",
        urlMasterAgentInfo: "/membership.svc/v1/masteragent/info"
    }
};